
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapid-magnetic-power-bank",
      function () {
        return require("private-next-pages/rapid-magnetic-power-bank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapid-magnetic-power-bank"])
      });
    }
  